import { render } from "./PostContent.vue?vue&type=template&id=0cb88649&scoped=true"
import script from "./PostContent.vue?vue&type=script&lang=js"
export * from "./PostContent.vue?vue&type=script&lang=js"

import "./PostContent.vue?vue&type=style&index=0&id=0cb88649&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb88649"]])

export default __exports__